import React from 'react';
import {Message, Button} from './lucky_components';
import successIcon from './lucky_components/components/molecules/Message/success.svg';
import errorIcon from './lucky_components/components/molecules/Message/error.svg';
const render_circle = (num, width) => {
    let final_num = parseInt(num * 360);
    let arr = [];
    for(let x = 0; x < 360; x++){
        if(x <= final_num){arr.push(true);}else{arr.push(false);}
    }
    let final_circle = 
        <svg height={width} width={width} class="custom_circle">
            {arr.map((ele, index)=>{
                let x = (width/2) + (width/2) * Math.cos(index * (Math.PI/180));
                let y = (width/2) + (width/2) * Math.sin(index * (Math.PI/180));
                return ele ? 
                    <line key={index} className="active" x1={(width/2)} y1={(width/2)} x2={x} y2={y} style={{stroke_width:1}} />
                :
                    <line key={index} x1={(width/2)} y1={(width/2)} x2={x} y2={y} style={{stroke_width:1}} />
            })}
            Sorry, your browser does not support inline SVG.
        </svg>;
        return final_circle;
                                
}
const render_error = () => {
    return (
        <div>
            <Message copy={"Ooops! something went wronge"} icons={errorIcon} />
        </div>
    )
}
const render_fail = (data) => {
    return (
        <div>
            <Message copy={data.data.message} icons={errorIcon} />
            <Button onClick={() => { window.location.href = data.url }}>Try again</Button>
        </div>
    )
}
const render_success = (data) => {
    return (
        <div>
            <Message 
                copy={"Lucky automatically calculates one easy monthly payment for all outstanding installments due"} 
                icons={successIcon} 
                head={"Payment Successful"}
            />
            <p className="success_p">Your next merged payment will now come from the card you've just entered.</p>
            <div className="success_card_div">
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.0721 2.93C15.6737 1.53118 13.8919 0.57847 11.952 0.192373C10.0121 -0.193724 8.0013 0.00413263 6.17386 0.76092C4.34643 1.51771 2.78446 2.79943 1.68551 4.44399C0.586566 6.08855 0 8.02206 0 10C0 11.9779 0.586566 13.9115 1.68551 15.556C2.78446 17.2006 4.34643 18.4823 6.17386 19.2391C8.0013 19.9959 10.0121 20.1937 11.952 19.8076C13.8919 19.4215 15.6737 18.4688 17.0721 17.07C18.0088 16.1462 18.7526 15.0455 19.2603 13.8318C19.7679 12.6181 20.0293 11.3156 20.0293 10C20.0293 8.68441 19.7679 7.38193 19.2603 6.16823C18.7526 4.95453 18.0088 3.85381 17.0721 2.93ZM8.91214 13.87C8.77399 14.0107 8.60895 14.1221 8.42685 14.1977C8.24475 14.2733 8.0493 14.3115 7.85214 14.31C7.65481 14.3127 7.45902 14.275 7.27675 14.1993C7.09448 14.1237 6.92958 14.0116 6.79214 13.87L4.00214 11.08L4.71214 10.38L7.49214 13.17C7.58729 13.2623 7.71461 13.3138 7.84714 13.3138C7.97966 13.3138 8.10699 13.2623 8.20214 13.17L15.2821 6.09L15.9821 6.8L8.91214 13.87Z" fill="#2CD18A"/>
                </svg>
                <p className="card_num">{data.data.card_subtype} {data.data.card_masked_pan}</p>
                <p>You can switch this card in the Lucky App</p>
                <a href="https://thelucky.app/" target="_blank" >Go to Lucky App 
                    <svg width="6" height="14" viewBox="0 0 6 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.18424 0.112349C0.398342 -0.0620492 0.713284 -0.0298631 0.887683 0.184239L5.57264 5.93577C5.70359 6.07081 5.80804 6.22935 5.88045 6.40315C5.95661 6.58594 5.99581 6.782 5.99581 6.98002C5.99581 7.17803 5.95661 7.37409 5.88045 7.55688C5.80816 7.7304 5.70394 7.8887 5.57328 8.02359L0.888748 13.8145C0.715074 14.0292 0.400243 14.0624 0.185552 13.8887C-0.0291381 13.7151 -0.0623886 13.4002 0.111285 13.1856L4.81129 7.37555C4.82275 7.36138 4.83498 7.34785 4.84792 7.33502C4.89478 7.28853 4.93198 7.23323 4.95736 7.1723C4.98275 7.11137 4.99581 7.04602 4.99581 6.98002C4.99581 6.91401 4.98275 6.84866 4.95736 6.78773C4.93198 6.7268 4.89478 6.6715 4.84792 6.62502C4.83538 6.61258 4.8235 6.59949 4.81235 6.58579L0.11235 0.815792C-0.0620482 0.60169 -0.0298621 0.286748 0.18424 0.112349Z" fill="#718897"/>
                    </svg>
                </a>
            </div>
            <div className="lucky_plans">
                {data.data.installments.details.map((plan, index) => {
                    return <p><span className="date">{render_circle(( (index + 1) / data.data.installments.details.length ) , 16)} {plan.date}</span><span className="amount">{data.data.currency + " " + plan.amount}</span></p>
                })}
            </div>
            <Button onClick={() => { window.location.href = data.url }}>Got it</Button>
        </div>
    )
}
const LuckyResult = (props) => {
    return (
        <div className="header__container">
            {!props.lucky_result_error ?
                props.lucky_result_data.success ?
                    render_success(props.lucky_result_data)
                :
                    render_fail(props.lucky_result_data)
            :
                render_error()
            }
        </div>   
    );
}

export default LuckyResult;